import { observer } from 'mobx-react';

import type { FormProps } from '../EditEntryDataForm';

import { translate } from '@chaika/i18n/helper';

import { ClinicUserSelect } from '@components/ModelSelect/ClinicUserSelect';
import { Button } from '@components/Button';

import { useCoAuthorsForm } from '../hooks/forms/useCoAuthorsForm';

import { EntryDataDataTest } from '../data-test';

interface Props extends FormProps {}

export const CoAuthorsForm = observer(({ entry }: Props): React.ReactElement<any> => {
    const { coAuthorIds, canSave, onCoAuthorsSelect, onSave } = useCoAuthorsForm({ entry });

    return (
        <>
            <ClinicUserSelect
                isMultiSelect
                dataTest={EntryDataDataTest.CoAuthorsSelect}
                userId={coAuthorIds}
                onChange={onCoAuthorsSelect}
            />
            <div>
                <Button
                    dataTest={EntryDataDataTest.CoAuthorsSave}
                    disabled={!canSave}
                    label={translate('save')}
                    onClick={onSave}
                />
            </div>
        </>
    );
});
